module.exports = __webpack_public_path__ + "static/media/undraw-campfire-s-6-y-4.86ed414d.svg";